import { getWorkplaceOrTFL } from './users.utils';

type Inviter = {
  title?: string;
  workplace?: string;
  firstName: string;
  lastName: string;
  notificationSettings?: {
    sms?: {
      senderName: string;
    };
  };
};

export const getIFunnelInvitationMessage = (inviter: Inviter, invitationLink: string) => {
  return [
    `Wir sind digital für Sie da! Verbinden Sie sich kostenlos mit uns, um Anliegen sicher & schnell zu klären: ${invitationLink}`,
    ...(!inviter.notificationSettings?.sms?.senderName ? [getWorkplaceOrTFL(inviter)] : []),
  ].join('\n');
};
export const getInvitationMessage = (inviter: Inviter, invitationLink: string) => {
  return [
    `Danke für Ihren Anruf! Um Ihnen schnell & sicher antworten zu können melden Sie sich hier an: ${invitationLink}`,
    ...(!inviter.notificationSettings?.sms?.senderName ? [getWorkplaceOrTFL(inviter)] : []),
  ].join('\n');
};
